/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TaskEvaluationSubjectScoreInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class TaskEvaluationSubjectScoreApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'TaskEvaluationSubjectScores');
  }

  //TODO remove, is not longer used anymore
  setTaskEvaluationSubjectScoresForTask(
    taskId: number,
    taskEvaluationSubjectScores: TaskEvaluationSubjectScoreInterface[]
  ): Observable<any> {
    const path = `task/${taskId}`;
    return this.post(path, undefined, taskEvaluationSubjectScores);
  }
}
